import api from '../../utils/api';
import { SalesSegment } from '~/types/SalesSegment';
import { SelectItem } from '~/types';

export async function getSalesSegment(): Promise<SalesSegment[]> {
  const { data } = await api.get(`/segmento_venda`);

  return data;
}

export async function getSalesSegmentAsSelect(): Promise<SelectItem[]> {
  const { data } = await api.get(`/segmento_venda`);

  const list = data.map((item: SalesSegment) => ({
    label: item.nome,
    value: item.id,
  }));

  return list;
}
